<template>
  <div id='rating-and-review'>
    <loading-modal v-if="this.show_loadding_api"></loading-modal>
    <div class="your-review">
      <div class="your-review-container">
        <star-rating v-model="customer_review.rating_score"
          :star-size='35'
          :show-rating='false'>
        </star-rating>
      </div>
      Nội dung đánh giá
      <textarea v-model='customer_review.comment' class="form-control" rows="5" placeholder="Để lại đánh giá của bạn về Cố vấn">
      </textarea>
      <div class="single-button">
        <div class="btn btn-success" @click="send_rating()">Gửi đi</div>
      </div>
    </div>
    <div class="list-review">
      <div v-for='review in reviews' class='review-container row'>
        <div class="col-md-2">
          <img v-if="review.customer_avatar != ''" class="customer_avatar" :src="review.customer_avatar">
          <img v-else class="customer_avatar" src='../../../assets/images/counselor/candidate.png'>
        </div>
        <div class="col-md-10">
          <div class="top-review row">
            <span class="col-md-6">
              <star-rating class='review-rating' 
                v-model="review.rating_score"
                :read-only="true"
                :max-rating="5"
                :star-size='20'
                :show-rating='false'>
              </star-rating>
            </span>
            <span class="col-md-6">
              <div class='review-date'>{{review.review_date}}</div>  
            </span>
            <div class="col-md-6 review-customer">{{review.customer_name}}</div>
          </div>
          <div class="middle-review">
            <div class='review-comment'>{{review.comment}}</div>
            <div class='review-rating'>
              <span>{{review.num_like}} <i class="btn fa fa-thumbs-up"></i></span>
              <span>{{review.num_dislike}} <i class="btn fa fa-thumbs-down"></i></span>
            </div>
          </div>          
        </div>        
      </div>
    </div>    
    <div v-if="!has_review()">Chưa có đánh giá nào</div>
    <div v-if="has_review()" class="button-group justify-content-md-center row">      
      <div class="show-more btn-success btn" @click="show_more()">Xem thêm</div>
      <div class="show-less btn-success btn" @click="show_less()">Ẩn đi</div>
    </div>
  </div>
</template>
<script>
  import LoadingModal from '../Modal/LoadingModal';
  import StarRating from 'vue-star-rating';
  import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
  import router from '../../../router';
  export default{
    components:{
      StarRating,
      LoadingModal
    },
    data: function(){
      return {
        customer_review: {
          rating_score: 5,
          comment: ''
        },
        show_loadding_api: false
      }
    },
    created: function(){
      this.$store.dispatch('vuex_rating_and_review/get_reviews', {
        id: this.$route.query.id,
        page: 1,
      });      
    },
    methods:{
      show_more: function(){
        var page = this.$store.state.vuex_rating_and_review.pagination_reivew.next_page        
        var total =this.$store.state.vuex_rating_and_review.pagination_reivew.total_rating
        if (page >-1 && page <= total){
          this.show_loadding_api = true
          this.$store.dispatch('vuex_rating_and_review/get_reviews', {
            id: this.$route.query.id,
            page: page,
          });
          this.show_loadding_api = false
        }
      },
      show_less: function(){
        var page = this.$store.state.vuex_rating_and_review.pagination_reivew.current_page -1
        this.show_loadding_api = true
        this.$store.dispatch('vuex_rating_and_review/get_reviews', {
          id: this.$route.query.id,
          page: page,
        });
        this.show_loadding_api = false
      },
      send_rating: function(){
        if (this.customer_review.comment == ''){
          alert('Nội dung không được để trống')
          return
        }
        if (this.$store.state.user.token){
          this.customer_review.counselor_id = this.$route.query.id
          this.show_loadding_api = true
          this.$store.dispatch('vuex_rating_and_review/send_rating', this.customer_review)
          this.show_loadding_api = false
        }
        else{
          alert('Bạn phải đăng nhập để sử dụng chức năng này')
        }
      },
      has_review: function(){
        return this.reviews.length > 0
      }
    },
    computed: {
      next_page(){
        return this.$store.state.vuex_rating_and_review.pagination_reivew.next_page
      },
      current_page(){
        return this.$store.state.vuex_rating_and_review.pagination_reivew.current_page
      },
      visible_show_more(){
        return this.$store.state.vuex_rating_and_review.pagination_reivew.next_page != -1
      },
      visible_show_less(){
        return his.$store.state.vuex_rating_and_review.pagination_reivew.current_page > 1
      },
      ...mapGetters('user',[
        'isAuthenticated'
      ]),
      ...mapState('vuex_rating_and_review',{
        reviews(state){          
          return state.reviews
        },
      })
    },
    // watch:{
    //   'store.vuex_rating_and_review.state.pagination_reivew'(newVal, oldVal){
    //     alert('test')
    //     this.notice_changed = test
    //   }
    // },
  };
</script>
<style lang="scss" scoped>
  @import "./rating_and_review.scss"
</style>


// WEBPACK FOOTER //
// src/views/components/Rating/RatingAndReview.vue